export enum EntityArea
{
    Demographic = 'demographics',
    Company = 'companies',
    User = 'users',
    Survey = 'surveys'
}